import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FIELDS = [["lead_time_days", "Varsayılan ithalat tedarik süresi (gün)"], ["coverage_days", "Hedef stok kapsama (gün)"], ["safety_days", "Emniyet stoğu (gün; taban: kritik stok)"]];
const num = (v) => (v === "" || v == null ? null : Number(v));

function CategoryRow({ c, edit, onSaved }) {
  const [v, setV] = useState({ lead_time_days: c.lead_time_days ?? "", coverage_days: c.coverage_days ?? "" });
  const save = async () => {
    try { await api.put("/smart-order/overrides/category", { category: c.name, lead_time_days: num(v.lead_time_days), coverage_days: num(v.coverage_days) }); toast.success(`${c.name} kaydedildi`); onSaved(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <tr data-testid={`so-cat-row-${c.name}`}><td>{c.name}</td>
      {["lead_time_days", "coverage_days"].map((k) => <td key={k}><Input type="number" min="0" className="h-8 w-24" placeholder="genel" value={v[k]} disabled={!edit}
        onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`so-cat-${k}-${c.name}`} /></td>)}
      <td>{edit && <Button size="sm" variant="outline" onClick={save} data-testid={`so-cat-save-${c.name}`}>Kaydet</Button>}</td></tr>
  );
}

export default function SmartOrderSettingsTab() {
  const { can } = useAuth();
  const edit = can("ayarlar", "edit");
  const [s, setS] = useState(null);
  const [f, setF] = useState(null);
  const load = () => api.get("/smart-order/settings").then(({ data }) => { setS(data); setF(data); });
  useEffect(() => { load(); }, []);
  if (!s) return <div className="panel h-32 animate-pulse" />;
  const save = async () => {
    try { await api.put("/smart-order/settings", { lead_time_days: Number(f.lead_time_days), coverage_days: Number(f.coverage_days), safety_days: Number(f.safety_days), lookback_days: Number(f.lookback_days), seasonality: !!f.seasonality }); toast.success("Akıllı sipariş ayarları kaydedildi"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="grid lg:grid-cols-2 gap-4 max-w-5xl" data-testid="smart-order-settings-tab">
      <div className="panel p-4 space-y-3">
        <h3 className="text-base font-semibold text-slate-800">Akıllı Sipariş Önerisi · Varsayılanlar</h3>
        {FIELDS.map(([k, l]) => <label key={k} className="flex items-center justify-between gap-3 text-sm">{l}
          <Input type="number" min="0" className="w-28 h-9" value={f[k]} disabled={!edit} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`so-${k}`} /></label>)}
        <label className="flex items-center justify-between gap-3 text-sm">Satış geriye bakış penceresi
          <select className="h-9 w-28 rounded-md border border-slate-300 px-2" value={f.lookback_days} disabled={!edit} onChange={(e) => setF({ ...f, lookback_days: e.target.value })} data-testid="so-lookback_days">
            {s.lookback_options.map((d) => <option key={d} value={d}>{d} gün</option>)}</select></label>
        <label className="flex items-center justify-between gap-3 text-sm">Mevsimsellik (geçen yıl aynı dönem × yıllık değişim)
          <Switch checked={!!f.seasonality} disabled={!edit} onCheckedChange={(c) => setF({ ...f, seasonality: c })} data-testid="so-seasonality" /></label>
        {edit && <Button size="sm" className="bg-blue-600 hover:bg-blue-700" onClick={save} data-testid="so-settings-save">Kaydet</Button>}
        <p className="text-xs text-slate-500">Ürün bazında geçersiz kılma: Akıllı Sipariş sayfasında satırın "Neden?" bölümünden. Öncelik: ürün → kategori → genel.</p>
      </div>
      <div className="panel p-4">
        <h3 className="text-base font-semibold text-slate-800 mb-2">Kategori Geçersiz Kılmaları</h3>
        <table className="dense-table w-full"><thead><tr><th>Kategori</th><th>Tedarik (gün)</th><th>Kapsama (gün)</th><th /></tr></thead>
          <tbody>{s.categories.map((c) => <CategoryRow key={c.name} c={c} edit={can("ayarlar", "edit") || can("ithalat", "edit")} onSaved={load} />)}</tbody></table>
      </div>
    </div>
  );
}
